import Home from '@/pages/Home'

routes = [
  {
    path: '/'
    name: 'Home'
    component: Home
  }
  {
    # 404 Catch all
    path: '*'
    redirect: '/' 
  }
]

export default routes 


// WEBPACK FOOTER //
// ./src/router/routes.coffee